import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

//files
import CMOFilterMultiSelect from './CMOFilterMultiSelect';
import { useStyles } from './Styles';
import FromToDateFilter from './FromToDateFilter';
import SearchSelect from './SearchSelect';
import MFGPlantFilter from './MFGPlantFilter';

const Filter = (props) => {
  const classes = useStyles();
  const {
    cmoFilter,
    handleSelectCMO,
    selectedCMOList,
    productSearch,
    handleProductSearchQuery,
    startDate,
    endDate,
    handleDateChange,
    CMOMemberId,
    filterByCMOName,
    mfgPlantFilter,
    handleSelectMFGPlant,
    selectedMFGPlantList,
    setMFGPlantList,
    setAllMFGPlantList,
    filteredMFGPlantList,
    filteredCMOList,
  } = props;

  return (
    <Grid container spacing={2} style={{ alignItems: 'end' }}>
      {cmoFilter && (
        <Grid item xs={12} sm={6} md={2} style={{ alignItems: 'end' }}>
          <Typography variant='body2' className={classes.filterField}>
            CMO:
          </Typography>
          <CMOFilterMultiSelect
            handleSelectCMO={handleSelectCMO}
            selectedCMOList={selectedCMOList}
            filteredCMOList={filteredCMOList}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={6} md={2} style={{ alignItems: 'end' }}>
          <Typography variant='body2' className={classes.filterField}>
            MFG Plant:
          </Typography>
          <MFGPlantFilter
            handleSelectMFGPlant={handleSelectMFGPlant}
            selectedMFGPlantList={selectedMFGPlantList}
            setMFGPlantList={setMFGPlantList}
            setAllMFGPlantList={setAllMFGPlantList}
            filteredMFGPlantList={filteredMFGPlantList}
          />
        </Grid>
     
      <Grid item xs={12} sm={6} md={3} style={{ alignItems: 'end' }}>
        <SearchSelect
          searchQuery={productSearch}
          handleSearchQuery={handleProductSearchQuery}
          CMOMember={CMOMemberId}
          selectedCMOList={selectedCMOList} 
          selectedMFGPlantList={selectedMFGPlantList}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} style={{ alignItems: 'end' }}>
        <FromToDateFilter
          startDate={startDate}
          endDate={endDate}
          handleDateChange={handleDateChange}
        />
      </Grid>
    </Grid>
  );
};

export default Filter;
